export enum OperatorType {
  LessThen = 1,
  GraterThen = 2,
  Equals = 3,
  StartsWith = 4,
  EndsWith = 5,
  Contains = 6,
  LessThenOrEqual = 7,
  GreaterThenOrEqual = 8,
  IsEmpty = 9,
  IsNotEmpty = 10,
  True = 11,
  False = 12,
  Between = 13,
  DoesNotEqual = 14,
  Select = 15,
}
